module.exports = __webpack_public_path__ + "img/415426-2.6de9beb2.png";